import {
	minPatchObject,
	minPatchPrimitive,
	minPatchRecord,
} from '@adflow/shared/util-superstruct';

import { DATA_TABLE_ITEM_TYPES } from './data-table-item-type';
import type { EditColumnTemplateSettingsDto } from './edit-column-template-settings.dto';

export const minPatchFullColumnTemplateSettings = minPatchRecord(
	DATA_TABLE_ITEM_TYPES,
	minPatchObject<EditColumnTemplateSettingsDto>({
		defaultColumnTemplateId: minPatchPrimitive,
	})
);
